import { createSelector } from 'reselect';

export const getChatActivity = createSelector(
  (state) => state.chats.data.chatActivity,
  (chatActivity) => {
    return chatActivity;
  }
);
